import React from "react";
import { Table } from "antd";

import "./styles.css";
import { format } from "../../../../../utils/MoneyFormater";

const columns = [
  {
    title: "Contrato",
    dataIndex: "contrato",
    key: "contrato"
  },
  {
    title: "Carteira/Produto",
    dataIndex: "carteira_produto",
    key: "carteira_produto"
  },
  {
    title: "Percentual",
    dataIndex: "percentual",
    key: "percentual",
    render: text => `${text}%`
  },
  {
    title: "Valor do Contrato",
    dataIndex: "valor_do_contrato",
    key: "valor_do_contrato",
    render: value => `R$ ${format(value)}`
  },
  {
    title: "Valor total",
    dataIndex: "valor_total",
    key: "valor_total",
    render: value => `R$ ${format(value)}`
  }
];

export function AcordoContratos({ contratos }) {
  return (
    <div className="acordocontratos">
      <h1 className="acordocontratos__title">Contratos renegociados</h1>

      <div>
        <Table
          columns={columns}
          dataSource={(contratos || []).map(contrato => ({
            key: contrato.contrato,
            contrato: contrato.contrato,
            carteira_produto: contrato.carteira_produto,
            percentual: contrato.percentual || 0,
            valor_do_contrato: contrato.valor_do_contrato || 0,
            valor_total: contrato.valor_total || 0
          }))}
          pagination={false}
          locale={{
            emptyText: "Sem contratos."
          }}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/AcordoContratos/index.jsx